<template>
    <div>
       对接模组
    </div>
</template>

<script>
export default {
    data() {
        return {}
    }
}
</script>
